import { call, takeLatest, fork, all } from 'redux-saga/effects';
import fileSaver from 'file-saver';

const DOWNLOAD_FILE = 'vtn/download-file/DOWNLOAD_FILE';

function* createFileDownload(file, fileName) {
  yield call(
    fileSaver.saveAs,
    new Blob([file], { type: 'text/plain;charset=utf-8' }),
    `${fileName}.json`
  );
}

function* watchDownloadFile() {
  yield takeLatest(DOWNLOAD_FILE, action =>
    createFileDownload(action.payload.file, action.payload.fileName)
  );
}

export default function* root() {
  yield all([fork(watchDownloadFile)]);
}

export function downloadFile(file, fileName) {
  return {
    type: DOWNLOAD_FILE,
    payload: {
      file,
      fileName
    }
  };
}



// WEBPACK FOOTER //
// ./src/client/modules/download-file.js